import moment from 'moment';
import 'jquery.cookie';
import trackingDefaultDataTypesHydrator from '../trackingDefaultDataTypes';
import getSupplierQtyParams from './getSupplierQtyParams';

const trackingHotelSupplierPricesHydrator = async (options) => {
    const {
        tourCriteria,
        productTypeByFilterCriteria = null,
        supplierBlocksPerDate = [],
    } = options;

    const countries = tourCriteria?.get('countries');
    const resorts = tourCriteria?.get('resorts');
    const hotels = tourCriteria.get('hotels');
    const checkInDateRange = tourCriteria?.get('checkInDateRange') || 0;
    const nightRange = tourCriteria?.get('nightRange') || 0;
    const touristGroup = tourCriteria?.get('touristGroup') || 0;
    const trackingDefaultDataTypes = await trackingDefaultDataTypesHydrator(options);

    return {
        toCountry: countries?.length ? countries.pluck('id')[0] : 0,
        toCity: resorts?.length ? resorts.pluck('id')[0] : 0,
        hotel: hotels?.length ? hotels.pluck('id')[0] : 0,
        dateFrom: checkInDateRange ? moment(checkInDateRange.get('from')).format('YYYY-MM-DD') : 0,
        dateTo: checkInDateRange ? moment(checkInDateRange.get('to')).format('YYYY-MM-DD') : 0,
        nightFrom: nightRange?.get('from') || 0,
        nightTo: nightRange?.get('to') || 0,
        adults: touristGroup ? touristGroup.get('adults') : 0,
        kids: touristGroup ? touristGroup.get('kids') : 0,
        infants: touristGroup ? touristGroup.get('infants') : 0,
        productTypeByFilterCriteria,
        supplierBlocksPerDate,
        ...getSupplierQtyParams(options.foundTours),
        ...trackingDefaultDataTypes,
    };
};

export default trackingHotelSupplierPricesHydrator;
